
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelOfferAnnualEscalated',
    props: { claiming: { type: Boolean, default: false } },
    emits: ['claim', 'decline', 'stay'],
});
